export const API_URL = '/api/';
export const ALLIEDMASTERAPIHOME = '/api/alliedmaster/';
export const MASTERAPIHOME = '/api/master/';
export const DISTRIBUTORMASTERAPIHOME = '/api/DistributorMaster/';
export const DISTRIBUTORMAPPINGAPIHOME = '/api/DistributorMapping/';
export const ORGDISTRIBUTORMAPPINGAPIHOME = '/api/OrgDistributorMapping/';
export const ACCOUNTDETAILAPIHOME = '/api/AccountDetail/';
export const SURGEONDETAILAPIHOME = '/api/SurgeonDetail/';
export const REUPLOADLAPIHOME = '/api/Reupload/';
export const ONINVOICEMASTERAPIHOME = '/api/ONInvoiceMaster/';
export const ONINVOICEDETAILAPIHOME = '/api/ONInvoiceDetail/';
export const DATAUPLOADSTATUSAPIHOME = '/api/DataUploadStatus/';
export const NRRAPIHOME = '/api/NetRealizationRate/';
export const CLOSEMONTHAPIHOME = '/api/ONCloseMonth/';
export const RAISETICKETAPIHOME = '/api/RaiseTicket/';
export const DATAUPLOADAPIHOME = '/api/DataUpload/';
export const LATESTMASTERAPIHOME = '/api/LatestMasterImportTrack/';
export const RAISETICKETRADIOAPIHOME = '/api/RaiseTicket/';
export const USERMASTERAPIHOME = '/api/UserMaster/';
export const DISTRIBUTORCONFIGURATIONAPIHOME = '/api/DistributorConfiguration/';
export const DASHBOARDAPIHOME = '/api/Dashboard/';
export const NOTIFICATIONAPIHOME = '/api/Notifications/';
export const SYSTEMSETTINGAPIHOME = '/api/SystemSettings/';
export const TRANSACTIONREPORTAPIHOME = '/api/TransactionReport/';
export const SNSUPLOADAPIHOME = '/api/SNSUpload/';
export const SNSUPLOADV2APIHOME = '/api/SNSUploadV2/';
export const SNSUPLOADV3APIHOME = '/api/SNSUploadV3/';
export const REPROCESSZYLEMDATAAPIHOME = '/api/ReprocessZylemData/';
export const HELPAPIHOME = '/api/HelpAndCommunication/';
export const SIGNINAPI = '/api/usersignin/';
export const COLUMNDEFAPIHOME = '/api/ColumnDefinition/';

export const configFileURL = '/siteconfig/AppConfig.json';






